import React from 'react';

const PageHeader = ({ title, count, description, actions }) => (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div>
            <div className="flex items-center gap-2">
                <h1 className="text-lg font-semibold">{title}</h1>
                {count != null && <span className="badge badge-ghost badge-sm font-normal">{count}</span>}
            </div>
            {description && <p className="text-sm text-base-content/60 mt-0.5">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
);

export default PageHeader;
